"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icons_1 = require("../../icons/Icons");
var DomUtil_1 = require("../../utils/DomUtil");
var Overlay_1 = require("../../utils/Overlay");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
// tslint:disable-next-line:max-line-length
var TooltipConsts_1 = require("./TooltipConsts");
exports.TooltipPosition = TooltipConsts_1.TooltipPosition;
function isFocusEvent(e) {
    return e.type === 'focus';
}
// tslint:disable-next-line:max-line-length
var DefaultTriggerElement = React.createElement("img", { draggable: false, src: Icons_1.encodeSvg("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\"><path fill=\"#666\" fill-rule=\"evenodd\" d=\"M8.5 1C12.6 1 16 4.4 16 8.5S12.6 16 8.5 16 1 12.6 1 8.5 4.4 1 8.5 1zm0 1C4.9 2 2 4.9 2 8.5S4.9 15 8.5 15 15 12.1 15 8.5 12.1 2 8.5 2zM9 7v5H8V7h1zm0-2v1H8V5h1z\"/></svg>") });
/**
 * Wrapper which displays a popup when the child element receives focus or is hovered.
 *
 * **NOTE**: this component is for static tooltip content only. It is not WCAG-compliant to put interactive content
 * inside the tooltip.
 *
 * @example
 *  <Tooltip getContent={() => 'Some interesting info'}>
 *    <span>Hover here for more info</span>
 *  </Tooltip>
 */
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tooltipId = DomUtil_1.generateId();
        _this.tooltipContentElement = null;
        _this.waitingOnGetContent = false;
        _this.state = {
            anchorClientRect: undefined,
            content: undefined,
            width: undefined,
        };
        _this.handleTooltipOverlayContentRef = function (element) {
            _this.tooltipContentElement = element ? element.firstElementChild : null;
        };
        _this.handleFocus = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.showTooltipOverlay(e);
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onFocus) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleBlur = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.dismissTooltipOverlay();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onBlur) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleKeyUp = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.state.content && _this.state.anchorClientRect && e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                _this.dismissTooltipOverlay();
            }
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onKeyUp) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleMouseEnter = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.showTooltipOverlay(e);
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onMouseEnter) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleMouseMove = ReactHelpers_1.mergeEventHandlers(function (e) {
            if (_this.state.content && _this.state.anchorClientRect && !_this.props.followCursor) {
                return;
            }
            _this.showTooltipOverlay(e);
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onMouseMove) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.handleMouseLeave = ReactHelpers_1.mergeEventHandlers(function (e) {
            _this.dismissTooltipOverlay();
        }, function (e) { var _a, _b, _c; return (_c = (_a = _this.props.children) === null || _a === void 0 ? void 0 : (_b = _a.props).onMouseLeave) === null || _c === void 0 ? void 0 : _c.call(_b, e); });
        _this.showTooltipOverlay = function (e) {
            var _a, _b;
            if (_this.props.onlyShowWhenClipped && !DomUtil_1.isElementOverflownX(e.currentTarget)) {
                return;
            }
            _this.setState({ anchorClientRect: _this.getAnchorClientRectFromEvent(e) });
            if (_this.state.content || _this.waitingOnGetContent) {
                return;
            }
            _this.waitingOnGetContent = true;
            var setContent = function (newContent) {
                if (_this.waitingOnGetContent) {
                    Tooltip.dismissDisplayedTooltip();
                    Tooltip.displayedTooltip = { dismiss: _this.dismissTooltipOverlay, id: _this.tooltipId };
                    _this.setState({ content: newContent }, function () { _this.waitingOnGetContent = false; });
                }
            };
            var content = (_b = (_a = _this.props).getContent) === null || _b === void 0 ? void 0 : _b.call(_a);
            if (!content) {
                _this.dismissTooltipOverlay();
            }
            else if (Promise.resolve(content) === content) {
                content
                    .then(setContent)
                    .catch(function (error) {
                    console.warn({ message: "'getContent' promise rejected", error: error });
                    _this.setState({ anchorClientRect: undefined, content: undefined, width: undefined }, function () { _this.waitingOnGetContent = false; });
                });
            }
            else {
                setContent(content);
            }
        };
        _this.dismissTooltipOverlay = function () {
            if (Tooltip.displayedTooltip && _this.tooltipId === Tooltip.displayedTooltip.id) {
                Tooltip.displayedTooltip = undefined;
            }
            _this.waitingOnGetContent = false;
            _this.setState({ anchorClientRect: undefined, content: undefined, width: undefined });
        };
        _this.getAnchorClientRect = function () { return _this.state.anchorClientRect; };
        return _this;
    }
    Tooltip.dismissDisplayedTooltip = function () {
        if (Tooltip.displayedTooltip) {
            var displayedTooltip = tslib_1.__assign({}, Tooltip.displayedTooltip);
            Tooltip.displayedTooltip = undefined;
            try {
                displayedTooltip.dismiss();
            }
            catch (error) {
                console.warn({ message: 'failed to dismiss displayed tooltip', error: error });
            }
        }
    };
    Tooltip.prototype.componentDidMount = function () {
        this.updateWidth();
    };
    Tooltip.prototype.componentDidUpdate = function () {
        this.updateWidth();
    };
    Tooltip.prototype.componentWillUnmount = function () {
        this.dismissTooltipOverlay();
    };
    Tooltip.prototype.updateWidth = function () {
        if (this.state.content && this.state.anchorClientRect && this.tooltipContentElement && this.state.width === undefined) {
            this.setState({ width: this.tooltipContentElement.getBoundingClientRect().width + TooltipConsts_1.AggregateTooltipPadding });
        }
    };
    Tooltip.prototype.getAnchorClientRectFromEvent = function (e) {
        if (isFocusEvent(e) && this.state.anchorClientRect) {
            return this.state.anchorClientRect;
        }
        else if (isFocusEvent(e) || !this.props.followCursor) {
            return TooltipConsts_1.adjustClientRectForOffset(e.currentTarget.getBoundingClientRect());
        }
        else {
            return TooltipConsts_1.adjustClientRectForOffset({
                bottom: e.clientY,
                height: 0,
                left: e.clientX,
                right: e.clientX,
                top: e.clientY,
                width: 0,
            });
        }
    };
    Tooltip.prototype.renderChildren = function () {
        var _a, _b;
        return (React.cloneElement(React.Children.only(this.props.children), {
            'aria-describedby': this.state.anchorClientRect ? this.tooltipId : undefined,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyUp: this.handleKeyUp,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseMove: this.handleMouseMove,
            tabIndex: (_b = (_a = this.props.children) === null || _a === void 0 ? void 0 : _a.props.tabIndex, (_b !== null && _b !== void 0 ? _b : 0)),
        }));
    };
    Tooltip.prototype.renderTooltipOverlay = function () {
        if (!this.state.content || !this.state.anchorClientRect) {
            return undefined;
        }
        var tooltipSideProps = TooltipConsts_1.TooltipPositionInfoMap[this.props.position];
        /**
         * In order to have the content wrapper grow to fit the tooltip contents, we initially render the wrapper with a width of maxWidth.
         * Once the tooltip content is rendered, we get a reference to the content element and get the actual rendered width. This width is
         * then used, along with the left/right padding and border widths to calculate the width of the content wrapper. This results in a
         * content wrapper that fits to the tooltip content.
         */
        var contentWrapperStyle = tslib_1.__assign(tslib_1.__assign({}, TooltipConsts_1.ContentWrapperStyle), { maxWidth: this.props.maxWidth, overflow: 'hidden', visibility: this.state.width === undefined ? 'hidden' : 'visible', width: Math.ceil(this.state.width || this.props.maxWidth) });
        return (React.createElement(Overlay_1.Overlay, { allowAutoPosition: true, anchorOrigin: tooltipSideProps.anchorOrigin, disablePointerEvents: true, getAnchorClientRect: this.getAnchorClientRect, shouldAutoPositionOnScrollingRootScroll: this.props.followCursor, stackedOrigin: tooltipSideProps.stackedOrigin, 
            // tslint:disable-next-line:deprecation
            stackingRootId: this.props.stackingRootId, zIndex: this.props.zIndex },
            React.createElement("div", { "data-tb-test-id": this.props.testId, id: this.tooltipId, ref: this.handleTooltipOverlayContentRef, role: 'tooltip', style: contentWrapperStyle }, this.state.content)));
    };
    Tooltip.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            this.renderChildren(),
            this.renderTooltipOverlay());
    };
    Tooltip.defaultProps = {
        children: DefaultTriggerElement,
        maxWidth: TooltipConsts_1.DefaultMaxWidth,
        position: TooltipConsts_1.TooltipPosition.Right,
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map